<template>
  <div>
    <v-btn
      color="warning"
      class="white--text"
      @click.stop="dialog = true"
      dark
      icon
      ><v-icon>mdi-pencil</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-form ref="form">
        <v-card>
          <v-card-title class="pa-0 pt-4 pl-5">
            <span>ยืนยันสิทธิ์ผู้ใช้งาน</span>
          </v-card-title>
          <v-card-title class="pa-0 pt-2 pl-5 pb-4">
            <img src="../../assets/img/linemd.png" width="60px" />
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form">
                <v-row no-gutters>
                  <v-col cols="12" sm="4">
                    <v-subheader>ชื่อผู้ใช้งาน :</v-subheader>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-text-field
                      color="#0D8EEE"
                      outlined
                      dense
                      label="ชื่อ"
                      disabled
                      v-model="user.displayName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-subheader>permission :</v-subheader>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-select
                      v-model="role"
                      :items="storePermission"
                      outlined
                      dense
                      label="permission"
                      item-text="role"
                      item-value="roleID"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn color="#033666" outlined @click="validclose"> ปิด </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#033666" @click="EditRole" dark> ยืนยันสิทธิ์ </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  props: ["user"],
  data: () => ({
    dialog: false,
    role: "",
  }),
  created() {
    this.role = this.user.roleID;
  },
  computed: {
    storePermission() {
      return this.$store.state.permissionlist;
    },
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.role = newValue.roleID;
      },
    },
  },
  methods: {
    EditRole() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("UpdateRole", {
            surveyID: this.$route.params.surveyID,
            roleID: this.role,
            userID: this.user.userID,
          })
          .then(() => {
            Swal.fire({
              icon: "success",
              text: "แก้ไขเรียบร้อยแล้ว",
              title: "",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.$store.dispatch("getPermission");
              this.$store.dispatch("getRole");
              this.validclose();
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              text:
                error.data.message === "role is duplicate"
                  ? "มีการใช้ชื่อนี้ไปแล้ว"
                  : error.data.message === "Permission Denied"
                  ? "คุณไม่มีสิทธิ์เข้าถึงการแก้ไข"
                  : "ไม่สามารถแก้ไขได้",
              title: "",
            }).then(() => {
              this.$store.commit("ToggleLoading");
              if (error.data.message === "Permission Denied") {
                this.$store
                  .dispatch(
                    "getQuestionPermission",
                    this.$route.params.surveyID
                  )
                  .then(() => {
                    this.$router.push({
                      name: "question",
                    });
                  });
              }
            });
          });
      }
    },
    validclose() {
      this.dialog = false;
      this.role = this.user.roleID;
    },
  },
};
</script>
